(function () {
  var loader = document.currentScript;
  var modules = {
    nav: { src: loader.dataset.navSrc, selector: '[data-nav-drawer-toggle]' },
    search: { src: loader.dataset.searchSrc, selector: '[data-search-drawer-toggle]' },
    delivery: { src: loader.dataset.deliverySrc, selector: '[data-delivery-location-toggle]' },
    giftBox: { src: loader.dataset.giftBoxSrc, selector: '[data-gift-box-toggle], [data-gift-box-remove]' },
    stickyHeader: { src: loader.dataset.stickyHeaderSrc },
  };

  function load(module) {
    if (!module.src) return Promise.resolve();
    if (module.promise) return module.promise;

    module.promise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = module.src;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return module.promise;
  }

  function matchModule(target) {
    return Object.values(modules).find(function (module) {
      return module.src && module.selector && target.closest(module.selector);
    });
  }

  function warmModule(event) {
    var module = matchModule(event.target);
    if (module) load(module).catch(function () {});
  }

  document.addEventListener('pointerover', warmModule, { passive: true, capture: true });
  document.addEventListener('touchstart', warmModule, { passive: true, capture: true });
  document.addEventListener('focusin', warmModule, true);

  document.addEventListener(
    'click',
    function (event) {
      var module = matchModule(event.target);
      if (!module || module.loaded) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      var trigger = event.target.closest(module.selector);

      load(module)
        .then(function () {
          module.loaded = true;
          trigger.click();
        })
        .catch(function () {
          if (trigger.href) window.location.assign(trigger.href);
        });
    },
    true
  );

  function loadDeferredModules() {
    // These two modules have automatic behavior. The remaining modules load
    // only when a visitor shows intent to use their controls.
    [modules.delivery, modules.stickyHeader].forEach(function (module) {
      load(module)
        .then(function () {
          module.loaded = true;
        })
        .catch(function () {});
    });
  }

  if (document.readyState === 'complete') {
    loadDeferredModules();
  } else {
    window.addEventListener('load', loadDeferredModules, { once: true });
  }
})();
